import { Component, OnInit } from '@angular/core';

import { UserMfaDevice } from '@lib/api/entities';
import { snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-mfa-table',
  templateUrl: './mfa-table.component.html',
  styleUrls: ['./mfa-table.component.scss'],
  animations: [snFadeIn, snFadeOut],
})
export class MfaTableComponent extends SnTableBaseComponent<UserMfaDevice> implements OnInit {
  constructor() {
    super();
  }

  public ngOnInit(): void {}

  public trackBy(index: number, item: UserMfaDevice): any {
    return item.id;
  }
}
